@if (hasCurrentTemplate()) {
	<div class="ib-main" [ngClass]="{hidden: hidden()}" [style]="{'--mep-ib-banner-height': currentShownBanner().height}">
		<ng-container
			[ngTemplateOutlet]="getCurrentTemplate()"
			[ngTemplateOutletContext]="currentShownBanner().template.templateData"
		>
		</ng-container>
	</div>
}

<ng-template #cookieBanner let-onConsent="onConsent" let-onNotConsent="onNotConsent">
	<span class="ib-text" [innerHTML]="_lang('cookie-banner.text')"> </span>

	<div class="ib-cookieBanner-button-wrapper">
		<button class="mep-btn-big" [disabled]="hidden()" (click)="hideBanner(); onNotConsent()">
			{{ _lang("cookie-banner.not-consent") }}
		</button>
		<button class="mep-btn-big" [disabled]="hidden()" (click)="hideBanner(); onConsent()">
			{{ _lang("cookie-banner.consent") }}
		</button>
	</div>
</ng-template>

<ng-template
	#msgBanner
	let-msg="msg"
	let-bannerAcknowledged="bannerAcknowledged"
	let-icon="style.icon"
	let-largeText="style.largeText"
	let-background="style.background"
	let-dismissible="dismissible"
>
	<span
		class="ib-text {{ icon !== undefined ? 'ib-icon-banner' : '' }} {{ 'large-text-' + largeText }} {{ background }}"
	>
		@if (icon !== undefined) {
			<mat-icon class="material-symbols-rounded">
				{{ icon }}
			</mat-icon>
		}
		<div [innerHTML]="msg"></div>
	</span>

	<button
		class="mep-btn-big"
		[hidden]="!isNil(dismissible) && !dismissible"
		[disabled]="hidden()"
		(click)="hideBanner(); bannerAcknowledged()"
	>
		{{ _lang("dismiss") }}
	</button>
</ng-template>
